import React, { useState, useEffect } from 'react';
import { Phone, Mail, Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import logo from '../assets/logo.png';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="container mx-auto px-4">
        {/* Top bar with contact info */}
        <div className="hidden md:flex items-center justify-end gap-6 py-2 border-b border-gray-200">
          <a
            href="tel:+919507331675"
            className="flex items-center gap-2 text-sm text-gray-700 hover:text-primary transition-colors"
          >
            <Phone size={16} className="text-primary" />
            <span>+91 9507331675</span>
          </a>
          <a
            href="mailto:info@coolantairsystems.com"
            className="flex items-center gap-2 text-sm text-gray-700 hover:text-primary transition-colors"
          >
            <Mail size={16} className="text-primary" />
            <span>info@coolantairsystems.com</span>
          </a>
        </div>

        {/* Main navigation */}
        <nav className="flex items-center justify-between py-4">
          <div className="flex items-center gap-2 logo-div">
            <img src={logo} alt="Logo" />
          </div>

          {/* Desktop menu */}
          <div className="hidden lg:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('hero')}
              className="text-gray-700 hover:text-primary transition-colors font-medium"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-primary transition-colors font-medium"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className="text-gray-700 hover:text-primary transition-colors font-medium"
            >
              Products
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="text-gray-700 hover:text-primary transition-colors font-medium"
            >
              Testimonials
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-primary transition-colors font-medium"
            >
              Contact
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-primary hover:bg-primary/90 text-white"
            >
              Get Free Consultation
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>

        {/* Mobile menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col gap-4">
              <button
                onClick={() => scrollToSection('hero')}
                className="text-left text-gray-700 hover:text-primary transition-colors font-medium"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="text-left text-gray-700 hover:text-primary transition-colors font-medium"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('products')}
                className="text-left text-gray-700 hover:text-primary transition-colors font-medium"
              >
                Products
              </button>
              <button
                onClick={() => scrollToSection('testimonials')}
                className="text-left text-gray-700 hover:text-primary transition-colors font-medium"
              >
                Testimonials
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-left text-gray-700 hover:text-primary transition-colors font-medium"
              >
                Contact
              </button>
              <div className="flex flex-col gap-2 pt-2 border-t border-gray-200">
                <a
                  href="tel:+919507331675"
                  className="flex items-center gap-2 text-sm text-gray-700"
                >
                  <Phone size={16} className="text-primary" />
                  <span>+91 9507331675</span>
                </a>
                <a
                  href="mailto:info@coolantairsystems.com"
                  className="flex items-center gap-2 text-sm text-gray-700"
                >
                  <Mail size={16} className="text-primary" />
                  <span>info@coolantairsystems.com</span>
                </a>
              </div>
              <Button
                onClick={() => scrollToSection('contact')}
                className="bg-primary hover:bg-primary/90 w-full "
              >
                Get Free Consultation
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
